import { createContext, useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import PublicClientAppService from '../../../application/platform/public/public-client-app-service';
import { IPublicClientResponse } from '../../../model/public/client/response/public-client-response';

type PublicClientState = {
    client?: IPublicClientResponse;
    clientId?: number;
    loading: boolean;
    error?: string;
};

const PublicClientContext = createContext<PublicClientState | undefined>(undefined);

export const PublicClientProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, setState] = useState<PublicClientState>({ loading: true });
    const { uf, citySlug } = useParams<{ uf: string; citySlug: string }>();

    useEffect(() => {
        if (!uf || !citySlug) return;

        const domainOverride = new URLSearchParams(window.location.search).get('domain');
        const domain = domainOverride || `${window.location.hostname}/${uf}/${citySlug}`;

        PublicClientAppService.findByDomain(domain)
            .then((client) => setState({ client, clientId: client.id, loading: false }))
            .catch(() => setState({ loading: false, error: 'Portal indisponível para este domínio.' }));
    }, [uf, citySlug]);

    return (
        <PublicClientContext.Provider value={state}>
            {children}
        </PublicClientContext.Provider>
    );
};

export const usePublicClientState = () => {
    const context = useContext(PublicClientContext);
    if (!context) throw new Error('usePublicClientState must be used within PublicClientProvider');
    return context;
};

export const usePublicPortalBasePath = () => {
    const { uf, citySlug } = useParams<{ uf: string; citySlug: string }>();
    return `/${uf}/${citySlug}/transparencia`;
};
